export const truncateAddress = (address, startChars = 6, endChars = 4) => {
  if (!address) return '';
  if (address.length <= startChars + endChars) return address;
  return address.slice(0, startChars) + '...' + address.slice(-endChars);
};

export const getNetworkLogoUrl = (network) => {
  if (network.logoUrl && network.logoUrl !== '') {
    return network.logoUrl;
  }
  return '/logo/image.png';
};

export const getNetworkImageUrl = (network) => {
  if (network.imageUrl && network.imageUrl !== '') {
    return network.imageUrl;
  }
  return null;
};

export const formatNetworkName = (name) => {
  return name ? name.replace(/\s+/g, '') : '';
};

export const copyToClipboard = async (text) => {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch (err) {
    console.error('Failed to copy:', err);
    return false;
  }
};
